import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {Alert, Card, defaultBorderColor, SimpleCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {FormattedMessage} from "react-intl";
import {twJoin} from "tailwind-merge";

type Props = {
    order: PlacedOrderOverview,
};

const NoteCard = ({order}: Props) => {
    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"note"}/>}/>
                </CardHeader>
            }
        >
            {order.note &&
                <Alert
                    type={"warning"}
                    title={<FormattedMessage id={"noteLeft"}/>}
                />
            }

            {
                order.note === null
                    ? <p><FormattedMessage id={"noNote"}/></p>
                    : (
                        <blockquote
                            className={(twJoin(
                                "mt-4 border p-3 rounded bg-gray-50 dark:bg-slate-700 text-sm",
                                defaultBorderColor,
                            ))}
                        >
                            <q>
                                {order.note}
                            </q>
                        </blockquote>
                    )
            }
        </Card>
    );
};

export default NoteCard;